document.addEventListener('DOMContentLoaded', () => {
    const lists = document.querySelectorAll('ul');

    lists.forEach(list => {
        const hoverAnchors = list.querySelectorAll('a.js-tab-hover');
        let activeAnchor: HTMLAnchorElement | null = null;

        const setActiveState = (anchor: HTMLAnchorElement, isActive: boolean) => {
            anchor.setAttribute('aria-selected', isActive.toString());

            const targetId = anchor.getAttribute('data-target');
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    targetElement.setAttribute('aria-hidden', (!isActive).toString());
                }
            }
        };

        hoverAnchors.forEach(anchor => {
            if (anchor.getAttribute('aria-selected') === 'true') {
                activeAnchor = anchor as HTMLAnchorElement;
            }
        });

        hoverAnchors.forEach(anchor => {
            anchor.addEventListener('mouseenter', function (this: HTMLAnchorElement) {
                if (activeAnchor && activeAnchor !== this) {
                    setActiveState(activeAnchor, false);
                }
                setActiveState(this, true);
                activeAnchor = this;
            });
        });
    });
});